"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carrierProfileMock = exports.userMock = void 0;
const userMock = (user) => ({
    cookies: [],
    featureFlags: [],
    firstLogin: true,
    firstName: 'John',
    fullNameWithoutTitle: 'John Doe',
    groupNames: [],
    id: '1235jf',
    uuid: '329a37ad-9b36-4df9-b0a8-78604ba8e87f',
    inCustomerGroup: false,
    inFinanceGroup: false,
    inStaffGroup: true,
    language: 'en',
    lastName: 'Doe',
    paymentTermPopUpDaysPast: 3,
    permissions: [],
    positionTitle: '',
    timezone: '',
    uiLanguage: 'en',
    username: 'john_doe@gmail.com',
    email: 'john_doe@gmail.com',
    ...user
});
exports.userMock = userMock;
exports.carrierProfileMock = {
    email: 'user@example.com',
    name: 'John Doe',
    picture: 'https://example.com/picture.jpg',
    id: '1234-5678-91011',
    language: 'en',
    consent: {
        marketingOptIn: false,
        marketingOptInAt: null
    },
    hasAcceptedLatestTerms: false
};
